import { render, staticRenderFns } from "./functionQuestionConfig.vue?vue&type=template&id=8a78acc2&scoped=true&"
import script from "./functionQuestionConfig.vue?vue&type=script&lang=js&"
export * from "./functionQuestionConfig.vue?vue&type=script&lang=js&"
import style0 from "./functionQuestionConfig.vue?vue&type=style&index=0&id=8a78acc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a78acc2",
  null
  
)

export default component.exports